module.exports = __webpack_public_path__ + "img/bet_rotate.a4c8d0cb.svg";